import { render } from "./BulkProductGridContainer.vue?vue&type=template&id=64996902"
import script from "./BulkProductGridContainer.vue?vue&type=script&lang=js"
export * from "./BulkProductGridContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__